import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'eurogard-feature-text-text',
  template: `
    @if (isDeprecated) {
      <span class="bg-[#ffa500] text-white font-black px-[2px] py-[1px] rounded-sm">DEPR</span>
    } @else {
      <span class="bg-[#1e88e5] text-white font-black px-[2px] py-[1px] rounded-sm">NEW</span>
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureInfoTextComponent {
  @Input() isDeprecated = false;
}
